import { Box, Divider, Stack, TextInput } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { tKeys, useTranslation } from 'locales/index';

import { openSearchSpotlight } from './SearchSpotlight';

// const hintProps = {
//   color: 'dimmed',
//   size: 'xs',
// };

// function useGetShortcutHints() {
//   return [
//     <Text {...hintProps}>
//       Press <Kbd size="xs">Ctrl</Kbd> + <Kbd size="xs">H</Kbd> to go to the dashboard
//     </Text>,
//     <Text {...hintProps}>
//       Press <Kbd size="xs">Ctrl</Kbd> + <Kbd size="xs">B</Kbd> to toggle the sidebar
//     </Text>,
//     <Text {...hintProps}>
//       Press <Kbd size="xs">/</Kbd> to access navigation
//     </Text>,
//     <Text {...hintProps}>
//       Press <Kbd size="xs">.</Kbd> to access quick actions
//     </Text>,
//     <Text {...hintProps}>
//       Press <Kbd size="xs">,</Kbd> to access global search
//     </Text>,
//   ];
// }

export const ShortcutHints = () => {
  const { t } = useTranslation();
  // const setIsShortcutsModalOpen = useSetAtom(IsShortcutsModalOpenAtom);
  // const hintToShow = sample(hints, 1);
  // const hints = useGetShortcutHints();

  return (
    <Stack w="100%">
      {/* <Center>
        <UnstyledButton tabIndex={-1} onClick={() => setIsShortcutsModalOpen(true)}>
          {hintToShow}
        </UnstyledButton>
      </Center> */}
      <Box onClick={openSearchSpotlight} style={{ cursor: 'pointer' }}>
        <TextInput
          style={{
            pointerEvents: 'none',
          }}
          placeholder={t(tKeys.SPOTLIGHT.PLACEHOLDER)}
          rightSection={<IconSearch size={14} stroke={1.5} />}
        />
      </Box>
      <Divider />
    </Stack>
  );
};
